import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Careers from './pages/Careers';
import ApplyNow from './pages/ApplyNow';
import ProductA from './pages/ProductA';
import ProductB from './pages/ProductB';
import ProductC from './pages/ProductC';
import ProductD from './pages/ProductD';
import AiEmployee from './pages/AiEmployee';
import Demos from './pages/Demos';
import LogisticsSolutions from './pages/LogisticsSolutions';
import IndustryInsurance from './pages/IndustryInsurance';
import IndustryRealEstate from './pages/IndustryRealEstate';
import IndustryRetail from './pages/IndustryRetail';
import IndustryHealthcare from './pages/IndustryHealthcare';
import IndustryFinance from './pages/IndustryFinance';
import IndustryManufacturing from './pages/IndustryManufacturing';
import IndustryGovernment from './pages/IndustryGovernment';
import SolutionA from './pages/SolutionA';
import SolutionB from './pages/SolutionB';
import SolutionC from './pages/SolutionC';
import SolutionD from './pages/SolutionD';
import SolutionE from './pages/SolutionE';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/sonner';

function App() {
  // Set dark mode by default
  React.useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Product pages */}
          <Route path="/product/ai-concierge" element={<ProductA />} />
          <Route path="/product/broadcast-commercials" element={<ProductB />} />
          <Route path="/product/ai-app-builder" element={<ProductC />} />
          <Route path="/product/enterprise-solutions" element={<ProductD />} />
          <Route path="/products/ai-employee" element={<AiEmployee />} />
          
          {/* Solutions pages */}
          <Route path="/solutions/customer-service" element={<SolutionA />} />
          <Route path="/solutions/sales" element={<SolutionB />} />
          <Route path="/solutions/finance" element={<SolutionC />} />
          <Route path="/solutions/human-resources" element={<SolutionD />} />
          <Route path="/solutions/operations" element={<SolutionE />} />
          <Route path="/solutions/industries/logistics" element={<LogisticsSolutions />} />
          <Route path="/solutions/industries/insurance" element={<IndustryInsurance />} />
          <Route path="/solutions/industries/real-estate" element={<IndustryRealEstate />} />
          <Route path="/solutions/industries/retail" element={<IndustryRetail />} />
          <Route path="/solutions/industries/healthcare" element={<IndustryHealthcare />} />
          <Route path="/solutions/industries/finance" element={<IndustryFinance />} />
          <Route path="/solutions/industries/manufacturing" element={<IndustryManufacturing />} />
          <Route path="/solutions/industries/government" element={<IndustryGovernment />} />
          
          {/* About & Careers - Single Pages */}
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/applynow" element={<ApplyNow />} />

          {/* Public live demos gallery */}
          <Route path="/demos" element={<Demos />} />

          {/* Legal pages */}
          <Route path="/legal/terms-of-service" element={<TermsOfService />} />
          <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" theme="dark" />
    </Router>
  );
}

export default App;
